import { validateConditionaly } from '@sravni/cosago-react-library/lib/validationSchemes';
import type { AnySchema } from 'yup';
import { mixed } from 'yup';

import type { TWorkplaceFormFields } from 'entities/creditForm';
import { EmploymentTypeDependencies } from 'entities/creditForm/model/creditForm.constants';

export const validateWorkFieldIfDepsEmploymentType = <T extends keyof TWorkplaceFormFields>(
  fieldName: T,
  fieldSchema: AnySchema,
  otherwiseSchema?: AnySchema,
) =>
  validateConditionaly<TWorkplaceFormFields[T]>(
    (employmentType: TWorkplaceFormFields['employmentType']) => {
      if (!employmentType?.value) {
        return true;
      }
      const value = String(employmentType?.value) as keyof typeof EmploymentTypeDependencies;
      return (value && (EmploymentTypeDependencies[value] || []).includes(fieldName)) || !employmentType;
    },

    () => fieldSchema,
    () => otherwiseSchema || mixed().nullable().optional(),
  )('employmentType');
